const WhatsYourMinimumHotelStandard = Object.freeze({
  THREE_STAR_COMFORTABLE: '3_star_comfortable',
  FOUR_STAR_QUALITY_MATTERS: '4_star_quality_matters',
  FIVE_STAR_BEST_AVAILABLE: '5_star_best_available',
  ULTRA_LUXURY: 'ultra_luxury',
} as const);

export type WhatsYourMinimumHotelStandard =
  (typeof WhatsYourMinimumHotelStandard)[keyof typeof WhatsYourMinimumHotelStandard];
export const allWhatsYourMinimumHotelStandard: [WhatsYourMinimumHotelStandard, ...WhatsYourMinimumHotelStandard[]] = Object.values(WhatsYourMinimumHotelStandard) as [WhatsYourMinimumHotelStandard, ...WhatsYourMinimumHotelStandard[]];

export default WhatsYourMinimumHotelStandard;

